import { MultiSelectCheckbox } from "./MultiSelectCheckbox";
import { SelectOptionLayout } from "./SelectOptionLayout";
export interface MultiSelectOption {
    label: string;
    value: string;
    description?: string;
}
export interface MultiSelectOptionProps {
    option: MultiSelectOption;
    selected: boolean;
}
export function MultiSelectOption({ option, selected }: MultiSelectOptionProps) {
    return <SelectOptionLayout label={option.label} description={option.description} prefix={<MultiSelectCheckbox checked={selected}/>}/>;
}
